import { graphql, useStaticQuery } from 'gatsby';

const useNewsfeedQuery = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpProductUpdate(
        filter: {isCptFrontPage: {eq: false}},
        limit: 4
      ) {
        nodes {
          title
          featuredImage {
            node {
              sizes
              sourceUrl
              srcSet
            }
          }
          date(formatString: "MMM D, YYYY")
          link
          templatesDefault {
            shortTitle
          }
          templatesEditorial {
            postTitle {
              shortTitle
            }
          }
        }
      }
    }
  `);

  return {
    categoryLink: '/product/whats-new',
    posts: data.allWpProductUpdate.nodes,
  };
};

export default useNewsfeedQuery;
